import './application.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'
import { ThemeProvider } from '../shared/theme/ThemeProvider'

void createInertiaApp({
  resolve: async (name) => {
    const pages = import.meta.glob<{ default: React.ComponentType }>([
      '../pages/register/**/*.tsx',
      '!../pages/register/**/*.{test,spec}.tsx',
    ])
    const loadPage = pages[`../pages/register/${name}.tsx`]
    if (!loadPage) throw new Error(`Unknown register page: ${name}`)
    return (await loadPage()).default
  },
  // Each page passes its own `title` to RegisterShell, which renders <Head>.
  // This appends the public service name so a shared link identifies itself,
  // and supplies the bare name for anything that has not set a title.
  title: (title) => (title ? `${title} – Mesterregisteret` : 'Mesterregisteret'),
  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
  setup({ el, App, props }) {
    createRoot(el!).render(
      <React.StrictMode>
        <ThemeProvider>
          <App {...props} />
        </ThemeProvider>
      </React.StrictMode>,
    )
  },
})
